import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './MenuItem.css'; // Assurez-vous de créer ce fichier CSS pour le style

const MenuItem = ({ item, addToCart }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imgError, setImgError] = useState(false);

  const handleAddToCart = () => {
    setIsAdding(true);
    addToCart(item);
    setTimeout(() => setIsAdding(false), 500); // Durée de l'animation
  };

  const handleImageClick = () => {
    if (!imgError) setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleImgError = () => setImgError(true);

  const modal = showModal ? ReactDOM.createPortal(
    <div className="modal-overlay" onClick={handleCloseModal}>
      <div className="modal-content" onClick={handleCloseModal}>
        {!imgError ? (
          <img
            src={`/assets/images/${item.image}`}
            alt={item.nom}
            className="modal-image"
            onError={handleImgError}
          />
        ) : (
          <div
            style={{
              width: '300px',
              height: '300px',
              backgroundColor: '#f5f4f4',
              background: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            className="modal-image"
          />
        )}
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <>
      <div className={`menu-item ${isAdding ? 'adding' : ''}`}>
        {!imgError ? (
          <img
            src={`/assets/images/${item.image}`}
            alt={item.nom}
            className={`item-image ${isAdding ? 'adding' : ''}`}
            onClick={handleImageClick}
            style={{ cursor: 'pointer' }}
            onError={handleImgError}
          />
        ) : (
          <div
            className="item-image"
            style={{
              width: '100px',
              height: '100px',
              background: '#f5f4f4',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'default'
            }}
          >
            <span>{item.image}</span>
          </div>
        )}
        <div className="item-info">
          <p className='gras'>{item.ref}. {item.nom}</p>
          <p>{item.description}</p>
          {item.precision && (
            <p className='precision'>{item.precision}</p>
          )}
        </div>
        <div className="item-action">
          <button className="add-button" onClick={handleAddToCart}>+</button>
          <span className="price">{item.prix} €</span>
        </div>
      </div>
      {modal}
    </>
  );
};

export default MenuItem;
